import { Injectable } from '@angular/core';
import {
  BankAccountDetails,
  ParrotClient,
  PolicyContribution,
  StatePolicy,
  TransferableContracts
} from '../MIF.Subscription.WebApi';

@Injectable({
  providedIn: 'root'
})
export class ParrotService {
  constructor(private webApi: ParrotClient) {}

  public async getBankAccountDetails(): Promise<BankAccountDetails[]> {
    return (await this.webApi.getBankAccountDetails().toPromise())!;
  }

  public async getTransferableContracts(productCode: string | undefined): Promise<TransferableContracts> {
    return (await this.webApi.getTransferableContracts(productCode).toPromise())!;
  }

  public async getPolicyByContractNumber(contractNumber: number | undefined): Promise<PolicyContribution[]> {
    return (await this.webApi.getPolicies(contractNumber).toPromise())!;
  }

  public async getPolicies(): Promise<StatePolicy[] | undefined> {
    return (await this.webApi.getPolicy()).toPromise()!;
  }
}
